import {create} from 'zustand';
import {createJSONStorage, persist} from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set) => ({
      // State
      user: null,
      token: '',
      isLoading: false,
      error: null,

      // UI state actions (not async operations)
      setUser: (user) => set({user}),
      setToken: (token) => set({token}),
      clearUser: () => {
        // localStorage.removeItem("authToken");
        // localStorage.removeItem("userToken");
        set({user: null});
        set({token: ''});
      },
      setError: (error) => set({error}),
      setLoading: (isLoading) => set({isLoading}),
    }),
    {
      name: 'mapex-auth-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({user: state.user, token: state.token}),
    },
  ),
);
